import find from 'lib/sequence/component/children/find'
import { get } from 'lib/sequence/component/state/value'

/**
 * Personal information step action.
 *
 * Sets the step as completed if all its required fields are filled.
 *
 * @param module the current module composition object
 */
export default (module: Gaia.AppModule.Spec) => component => async (...args) => {
  const stepState = component[G.STATE]
  const { type, account, firstName, lastName, phone, lang } = find(component)

  stepState.completed = [type, account, firstName, lastName, phone, lang].every(
    field => !!get(field),
  )

  stepState.confirmed = stepState.completed

  return args
}
